import {bool, func, object} from 'prop-types';
import {useState} from 'react';

import {useAddDayExercise} from '../api.js';
import {useNotifierContext} from '../NotifierContext.jsx';
import {useMutationCallback} from '../utils/hooks.js';
import ExerciseRepeatSwitch from './ExerciseRepeatSwitch.jsx';
import Dialog from './ui/Dialog.jsx';

export default function MesoDayExerciseDuplicateDialog({isOpen, onClose, dayExercise}) {
  const {exerciseId, dayId, position} = dayExercise;
  const {showNotification} = useNotifierContext();
  const duplicateDayExercise = useAddDayExercise(dayId, {meta: {action: 'duplicateDayExercise'}});
  const [repeat, setRepeat] = useState(false);

  const handleClose = useMutationCallback(onClose);
  const handleDuplicateExercise = useMutationCallback(() => {
    // Because we're duplicating we need to provide a target and source position
    const body = {
      exerciseId,
      targetPosition: position + 1,
      sourcePosition: position,
      repeat,
    };

    duplicateDayExercise.mutate(body, {
      onSuccess: () => {
        handleClose();
        showNotification({
          message: 'Exercise duplicated!',
          type: 'success',
          autoClose: true,
        });
      },
    });
  }, [duplicateDayExercise, exerciseId, handleClose, position, repeat, showNotification]);

  return (
    <Dialog isOpen={isOpen} onClose={handleClose} title="Add down set">
      <p>
        This will add another copy of the exercise right after this one. You can choose a different
        weight for it.
      </p>

      <div className="mt-8">
        <ExerciseRepeatSwitch repeat={repeat} setRepeat={setRepeat} />
      </div>

      <div className="mt-4 flex justify-end">
        <button className="btn btn-ghost mr-4" onClick={handleClose}>
          Cancel
        </button>

        <button
          disabled={duplicateDayExercise.isWorking}
          className="btn btn-accent"
          onClick={handleDuplicateExercise}
        >
          {duplicateDayExercise.isWorking && <span className="loading"></span>}
          Add down set
        </button>
      </div>
    </Dialog>
  );
}

MesoDayExerciseDuplicateDialog.propTypes = {
  dayExercise: object.isRequired,
  isOpen: bool.isRequired,
  onClose: func.isRequired,
};
